import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=13d53546&scoped=true&"
import script from "./AddQuestion.vue?vue&type=script&lang=ts&"
export * from "./AddQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./AddQuestion.vue?vue&type=style&index=0&id=13d53546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d53546",
  null
  
)

export default component.exports